import React, { useEffect } from 'react';
import { Paper } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';

import { liveTrackinglayoutSelector } from '../../features/layout/layoutSlice';
import { searchEventAssetId, eventViewTypeSelector } from '../../features/events/eventsSlice';

import AssetEventListView from './AssetEventListView';
const AssetEventsViewModal = ({ assetId }) => {

    const dispatch = useDispatch();
    const dimentions = useSelector(liveTrackinglayoutSelector);
    const eventViewType = useSelector(eventViewTypeSelector);

    useEffect(() => {
        if (eventViewType === 'oneAsset' && assetId) {
            dispatch(searchEventAssetId({ assetId }));
        }

    }, [dispatch, assetId, eventViewType]);

    return (
        <div style={dimentions.assetEventList}>
            {
                <Paper>
                    <AssetEventListView
                        assetId={assetId}
                    />
                </Paper>
            }
        </div>

    );
}

export default AssetEventsViewModal;